import { withAuthenticationRequired } from "@auth0/auth0-react";
import { IconLogo } from "../svgs";
import { LoaderStyles } from "../styles";
import { FourDotsLoader } from "./FourDotAnimation";

import React from "react";

export const AuthenticationGuard = ({ component, returnTo }) => {
  const Component = withAuthenticationRequired(component, {
    onRedirecting: () => (
      <LoaderStyles>
        <IconLogo className="gg-logo" />
        <FourDotsLoader />
      </LoaderStyles>
    ),
    returnTo,
  });

  return <Component />;
};
